//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ranksItem from "./history.vue";
export default {
  data() {
    return {
      chongzhiActive: 3,
      tabActive1: "chongzhi",
      hasCurrentEvents: false,
    };
  },
  components: {
    "c-ranksItem": ranksItem,
  },
  mounted() {
    if (this.$route.name == "rank") {
      this.chongzhiActive = 1;
      this.tabActive1 = "paihang";
    }
  },
  methods: {
    changetab(key) {
      if (key == 4) {
        this.$router.push({ name: "rank" });
      }
      this.chongzhiActive = key;
    },
    onSwtich(type) {
      this.tabActive1 = type;
      if (type == "paihang") {
        this.$router.push({ name: "rank" });
      }
    },
  },
};
